import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NavCartComponent } from "./nav-cart.component";
import { TranslateModule } from "@ngx-translate/core";
import { RouterModule } from "@angular/router";
import { NavCartContentComponent } from "./components/nav-cart-content/nav-cart-content.component";
import { PipesModule } from "src/app/pipes/pipes.module";

@NgModule({
  declarations: [NavCartComponent, NavCartContentComponent],
  imports: [CommonModule, TranslateModule, RouterModule, PipesModule],
  exports: [NavCartComponent],
})
export class NavCartModule {}
